
import React, { Fragment } from 'react'
import {AppButton,AppRow,AppGridBar} from 'qcc'

export const PosApiInputBar = (props:{fn?:()=>void}) =>{

    const execFn = () =>{
        props.fn && props.fn();
    }

    return (  <AppGridBar>
        <AppGridBar.Left>
            <div style={{paddingLeft:20}}>{'参数说明'}</div>
        </AppGridBar.Left>
        <AppGridBar.Right>
            <AppRow style={{float:'right',marginRight:20}}>
                <AppButton label='执行' type='primary' action={execFn} />
            </AppRow>
        </AppGridBar.Right>
    </AppGridBar>)
}


// WEBPACK FOOTER //
// ./src/posapi/components/PosApiInputBar.tsx